import React, { useCallback, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CircleDotIcon, LogOutIcon } from 'lucide-react';
import { Sidebar } from './components/Sidebar';
import { ThemeToggle } from './components/ThemeToggle';
import { CompletionProvider } from './contexts/CompletionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { planMeta } from './data/plan';
import { CalendarView } from './pages/CalendarView';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Production } from './pages/Production';
import { Products } from './pages/Products';
const SESSION_KEY = 'content-ops-authed';
export function App() {
  const [authed, setAuthed] = useState<boolean>(() => typeof window !== 'undefined' && window.sessionStorage.getItem(SESSION_KEY) === 'true');
  const signIn = useCallback(() => {
    window.sessionStorage.setItem(SESSION_KEY, 'true');
    setAuthed(true);
  }, []);
  const signOut = useCallback(() => {
    window.sessionStorage.removeItem(SESSION_KEY);
    setAuthed(false);
  }, []);
  if (!authed) {
    return <ThemeProvider data-id="element-0" data-mp="3mk83wrqn3zad">
        <Login onSuccess={signIn} data-id="element-1" data-mp="3mjga9mglsbmq" />
      </ThemeProvider>;
  }
  return <ThemeProvider data-id="element-2" data-mp="3rcsy3udgkeef">
      <CompletionProvider data-id="element-3" data-mp="3recedkz46pg7">
      <BrowserRouter data-id="element-4" data-mp="5osn3wyp084">
        <div className="flex min-h-full w-full flex-col bg-ink-950 font-sans lg:flex-row" data-id="element-5" data-mp="680tswt8a8y">
          <Sidebar data-id="element-6" data-mp="2zlld2w2kqak3" />

          <div className="flex min-w-0 flex-1 flex-col" data-id="element-7" data-mp="2zmepodo7rua5">
            <header className="flex flex-wrap items-center justify-between gap-3 border-b border-ink-700 bg-ink-900/60 px-5 py-3 backdrop-blur" data-id="element-8" data-mp="33moqzd129wio">
              <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-mute" data-id="element-9" data-mp="38l06o4e1f18t">
                {planMeta.title} <span className="text-faint" data-id="element-10" data-mp="3dmfo7mh0apmg">/ {planMeta.window}</span>
              </p>
              <div className="flex items-center gap-4" data-id="element-11" data-mp="nur948fv0n11">
                <p className="hidden items-center gap-2 font-mono text-[11px] text-mute sm:flex" data-id="element-12" data-mp="sudk0b87tr6o">
                  <CircleDotIcon className="h-3.5 w-3.5 text-campaign" aria-hidden="true" data-id="element-13" data-mp="3684hdq2uasw" />
                  Live now: Laravel Free Weekend · {planMeta.today}
                </p>
                <ThemeToggle data-id="element-14" data-mp="3uf5i5nwu4h9b" />
                <button type="button" onClick={signOut} className="flex items-center gap-1.5 rounded-lg border border-ink-700 px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-mute transition-colors hover:border-ink-600 hover:text-chalk" data-id="element-15" data-mp="d57f31uekgij">
                  <LogOutIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-16" data-mp="3bnmf5h2t937a" />
                  Sign out
                </button>
              </div>
            </header>

            <main className="flex-1 px-5 py-7 sm:px-7 lg:px-9" data-id="element-17" data-mp="3ljxw4kdcih82">
              <Routes data-id="element-18" data-mp="3liehey7c8e8e">
                <Route path="/" element={<Overview data-id="element-20" data-mp="2xu3mscs8jask" />} data-id="element-19" data-mp="2xun2dmuexn3f" />
                <Route path="/calendar" element={<CalendarView data-id="element-22" data-mp="2svtm5mnqrhzk" />} data-id="element-21" data-mp="2xt287yc0g663" />
                <Route path="/products" element={<Products data-id="element-24" data-mp="2svjxq3ichivz" />} data-id="element-23" data-mp="2suqydnlptvnv" />
                <Route path="/production" element={<Production data-id="element-26" data-mp="18cq6dlx04itg" />} data-id="element-25" data-mp="18drk5y5ejjev" />
                <Route path="*" element={<Overview data-id="element-28" data-mp="1d4hmt3mg185v" />} data-id="element-27" data-mp="18cgfzx81o9n8" />
              </Routes>
            </main>
          </div>
        </div>
      </BrowserRouter>
      </CompletionProvider>
    </ThemeProvider>;
}